import { TIMEZONE_OPTIONS } from "utils/constants";

const isTimeOptionInSearchTerm = (
  timezoneOption: (typeof TIMEZONE_OPTIONS)[0],
  sectionName: string,
  searchText: string
) => {
  if (!searchText) {
    return true;
  }
  const searchTermLower = searchText.toLowerCase();
  const { label, location, abbreviation } = timezoneOption;
  return (
    label.toLowerCase().includes(searchTermLower) ||
    location.toLowerCase().includes(searchTermLower) ||
    abbreviation.toLowerCase().includes(searchTermLower) ||
    sectionName.toLowerCase().includes(searchTermLower)
  );
};

export const getFilteredSectionOptions = (
  tzCodes: string[],
  filteredOptions: typeof TIMEZONE_OPTIONS,
  sectionName: string,
  searchText: string
) => {
  const sectionOptions: typeof TIMEZONE_OPTIONS = [];
  tzCodes.forEach((code) => {
    const option = filteredOptions.find((option) => option.tzCode === code);
    if (!option) {
      return;
    }

    if (isTimeOptionInSearchTerm(option, sectionName, searchText)) {
      sectionOptions.push(option);
    }
  });
  return sectionOptions;
};
